import { type NexusSignal, otto } from "@otto-ec/global-resources/nexus";
import type {
    RecoCinemasBounceLayerEventPayload,
    RecoCinemasWishlistEventPayload,
    RecoCinemasOrderOverviewEventPayload,
    DetailViewRenderRecommendationsEventPayload,
} from "@otto-ec/nexus-registry/reco/cinemas";

declare module "@otto-ec/nexus-registry/reco/cinemas" {
    interface RecoCinemasRaw {
        renderBounceLayerRecommendationsInternal: NexusSignal<RecoCinemasBounceLayerEventPayload>;
        renderWishlistRecommendationsInternal: NexusSignal<RecoCinemasWishlistEventPayload>;
        renderOrderOverviewRecommendationsInternal: NexusSignal<RecoCinemasOrderOverviewEventPayload>;
        renderAlternativeRecommendationsInternal: NexusSignal<DetailViewRenderRecommendationsEventPayload>;
        renderComplementaryRecommendationsInternal: NexusSignal<DetailViewRenderRecommendationsEventPayload>;
        renderProductLineRecommendationsInternal: NexusSignal<DetailViewRenderRecommendationsEventPayload>;
    }
}

export const {
    renderBounceLayerRecommendationsInternal,
    renderWishlistRecommendationsInternal,
    renderOrderOverviewRecommendationsInternal,
    renderAlternativeRecommendationsInternal,
    renderComplementaryRecommendationsInternal,
    renderProductLineRecommendationsInternal
} = otto.reco.cinemas;

const targetMapping = {
    alternative: renderAlternativeRecommendationsInternal,
    complementary: renderComplementaryRecommendationsInternal,
    productline: renderProductLineRecommendationsInternal,
};

const wishlistEventsBuffer: Map<string, any> = new Map();

export async function setUpInternalInterfaces() {
    if (!import.meta.env.SSR) {
        const {
            renderBounceLayerRecommendations,
            renderPdpRecommendations,
            renderWishlistRecommendations,
            renderOrderOverviewRecommendations,
        } = await import("@otto-ec/nexus-registry/reco/cinemas");
        renderBounceLayerRecommendations.assignFunction((payload) => {
            renderBounceLayerRecommendationsInternal.set(payload);
        });
        renderWishlistRecommendations.assignFunction((payload: any) => {
            wishlistEventsBuffer.set(payload?.variationId, payload);
            renderWishlistRecommendationsInternal.set(payload);
        });
        renderOrderOverviewRecommendations.assignFunction((payload) => {
            renderOrderOverviewRecommendationsInternal.set(payload);
        });
        renderPdpRecommendations.assignFunction((payload) => {
            const pdpHandler = targetMapping[payload.target];
            pdpHandler.set(payload);
        });
    }
}

export function getEventFromWishlistEventBuffer(variationId: string): any {
    return wishlistEventsBuffer.get(variationId);
}